import {
    FilterProps,
    isKmsTypeFilterCheckbox,
    isKmsTypeFilterDate,
    isKmsTypeFilterFreeText,
    isKmsTypeFilterRadio,
    SupportedKmsTypeFilter,
} from "@kaltura/mediaspace-shared-types";
import { CheckboxFilter } from "./checkbox-filter/CheckboxFilter";
import { RadioFilter } from "./radio-filter/RadioFilter";
import { FreeTextFilter } from "./free-text-filter/FreeTextFilter";
import DateFilter from "./date-filter/DateFilter";

/**
 * filter - a filter factory
 */
export function Filter(props: FilterProps<SupportedKmsTypeFilter>) {
    // `freeText` is a prop of KmsTypeFilterFreeText only, it is not part of the base,
    //  but it's ok because none of the other types will have it
    // it must be before singleSelection and multiSelection
    if (isKmsTypeFilterFreeText(props)) {
        return <FreeTextFilter {...props} />;
    }
    if (isKmsTypeFilterDate(props)) {
        return <DateFilter {...props} />;
    }

    // singleSelection and multiSelection can be on any filter, so must be last
    if (isKmsTypeFilterRadio(props)) {
        return <RadioFilter {...props} />;
    }

    if (isKmsTypeFilterCheckbox(props)) {
        return <CheckboxFilter {...props} />;
    }

    return null;
}

export default Filter;
